import React, { useEffect, useState } from 'react';
import { useProductVariantsInHeaderExperiment } from 'src/hooks/experiments';
import { PropertyList, Property, PlaceholderProperty } from './styles';
import { ProductCorePropertiesProps } from './types';

export const ProductCoreProperties = ({
  className,
  properties,
  toneDown,
  maxrows,
  size,
  showAsList,
  truncate,
}: ProductCorePropertiesProps) => {
  // Experiment on showing Variants and conditions in product header
  const [
    showProductVariantsInHeader,
    setShowProductVariantsInHeader,
  ] = useState(false);
  const productVariantsInHeaderExperiment = useProductVariantsInHeaderExperiment();

  useEffect(() => {
    setShowProductVariantsInHeader(productVariantsInHeaderExperiment);
  }, [productVariantsInHeaderExperiment]);

  const renderPropertiesByExperiment = () => {
    if (!properties)
      return <PlaceholderProperty toneDown={toneDown} size={size} />;

    const filteredProperties = properties.filter(v => v);

    return showProductVariantsInHeader ? (
      <li>{filteredProperties.join(', ')}</li>
    ) : (
      filteredProperties.map(value => (
        <Property key={value} showAsList={showAsList} truncate={truncate}>
          {value}
        </Property>
      ))
    );
  };

  return (
    <PropertyList
      className={className}
      toneDown={toneDown}
      maxRows={maxrows}
      size={size}
      showAsList={showAsList && !showProductVariantsInHeader}
    >
      {renderPropertiesByExperiment()}
    </PropertyList>
  );
};

ProductCoreProperties.defaultProps = {
  properties: undefined,
  toneDown: false,
  maxrows: undefined,
  size: 'large',
  showAsList: false,
  className: undefined,
  truncate: false,
};
